import React, { useState } from "react";
import "./JobForm.css";
import { nationalityOptions } from "./country";
import axios from "axios";

const JobForm = () => {
  const [formData, setFormData] = useState({
    uk_work_right: "",
    uk_driving_licence: "",
    proof_of_address: "",
    license_penalty_points: "",
    ability_to_lift_parcel: "",
    gender: "",
    address: "",
    address_alt: "",
    city: "",
    town: "",
    country: "",
    postcode: "",
    mobile_number: "",
    dob: "",
    email: "",
    emg_cont_first_name: "",
    emg_cont_mobile: "",
    nationality: "",
    first_name: "",
    surname: ""
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PHP_BASE_URL}/add_job_applications`,
        // "http://217.154.38.244/api/add_job_applications",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("API Response:", response.data);
      setSuccess(true);
      alert("Application submitted successfully!");
      setFormData({
        uk_work_right: "",
        uk_driving_licence: "",
        proof_of_address: "",
        license_penalty_points: "",
        ability_to_lift_parcel: "",
        gender: "",
        address: "",
        address_alt: "",
        city: "",
        town: "",
        country: "",
        postcode: "",
        mobile_number: "",
        dob: "",
        email: "",
        emg_cont_first_name: "",
        emg_cont_mobile: "",
        nationality: "",
        first_name: "",
        surname: ""
      });
    } catch (err) {
      console.error("API Error:", err);
      const errorMessage = err.response?.data?.message || "Failed to submit the application. Please try again.";
      setError(errorMessage);
      alert("Submission failed: " + errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const renderRadioGroup = (label, name, options) => (
    <div className="form-group">
      <label>{label} *</label>
      <div className="radio-group">
        {options.map((opt, index) => (
          <label key={opt} className="custom-radio">
            <input
              type="radio"
              name={name}
              value={opt}
              checked={formData[name] === opt}
              onChange={handleChange}
              required={index === 0}
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>
    </div>
  );

  const renderInput = (label, name, type = "text", required = true, options = []) => (
    <div className="form-group">
      <label>{label} {required && "*"}</label>
      <input
        type={type}
        name={name}
        list={options.length > 0 ? `${name}-list` : undefined}
        value={formData[name]}
        onChange={handleChange}
        required={required}
      />
      {options.length > 0 && (
        <datalist id={`${name}-list`}>
          {options.map((option) => (
            <option key={option} value={option} />
          ))}
        </datalist>
      )}
    </div>
  );

  return (
    <div className="form-container">
      {/* <h1 className="hr-heading">Yellow House</h1> */}
      <h3 className="form-title">Job Application Form</h3>
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">Application submitted successfully!</div>}
      <form onSubmit={handleSubmit}>
        {renderRadioGroup("Do you have a valid right to work in the UK?", "uk_work_right", ["Yes", "No"])}
        {renderRadioGroup("Do you have a UK or EU driving licence - Minimum 2 years old?", "uk_driving_licence", ["Yes", "No"])}
        {renderRadioGroup("Do you have proof of address (Council Tax, Water, Energy, Phone, Bank, Internet, or any Government Letter) no more than 3 months old?", "proof_of_address", ["Yes", "No"])}
        {renderRadioGroup("Do you have less than 6 penalty points on your driving licence?", "license_penalty_points", ["Yes - Clean", "Yes - Some Points But Less Than 6", "No"])}
        {renderRadioGroup("Do you have the ability to lift and carry parcels up to 25kg?", "ability_to_lift_parcel", ["Yes", "No"])}
        <div className="form-row">
          {renderInput("First Name", "first_name")}
          {renderInput("Surname", "surname")}
        </div>
        {renderRadioGroup("Gender", "gender", ["Male", "Female"])}
        {renderInput("Address", "address")}
        {renderInput("Address Line 2", "address_alt", "text", false)}
        {renderInput("City", "city")}
        {renderInput("Town", "town")}
        {renderInput("Country", "country")}
        {renderInput("Postcode", "postcode")}
        {renderInput("Mobile Number", "mobile_number")}
        {renderInput("Date of Birth", "dob", "date")}
        {renderInput("Email Address", "email", "email")}
        {renderInput("Emergency Contact First Name", "emg_cont_first_name")}
        {renderInput("Emergency Contact Mobile", "emg_cont_mobile")}
        {renderInput("Nationality", "nationality", "text", true, nationalityOptions)}
        <button type="submit" className="submit-btn" disabled={isLoading}>
          {isLoading ? "Submitting..." : "Apply Now"}
        </button>
      </form>
    </div>
  );
};

export default JobForm;